import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { getAdMetricSourceKey } from '~/swr-hooks/ads/meta/useAdMetricSource';
import { type AdsMetricSourcesQueryCacheType, isAdMetricSourcesKey } from '~/swr-hooks/ads/meta/useAdMetricSources';
import { type Ad } from '~/swr-hooks/ads/types';

export const useInvalidateAdMetricSources = () => {
  const queryClient = useQueryClient();

  const invalidateAdMetricSources = useCallback(
    (adId: Ad['id']) => {
      queryClient.removeQueries({ queryKey: getAdMetricSourceKey({ adId }) });
      queryClient.setQueriesData<AdsMetricSourcesQueryCacheType>(
        {
          predicate: (query) => isAdMetricSourcesKey(query.queryKey) && query.queryKey[1].adIds.includes(adId),
        },
        // Remove the ad id from the cache
        (old) => (old ? { ...old, [adId]: undefined } : { [adId]: undefined }),
      );
      queryClient.invalidateQueries({
        predicate: (query) => isAdMetricSourcesKey(query.queryKey) && query.queryKey[1].adIds.includes(adId),
      });
    },
    [queryClient],
  );

  return {
    invalidateAdMetricSources,
  };
};
